import { authFetch } from './api';

let printFrame = null;

// Charge un PDF dans un iframe caché puis ouvre le dialogue d'impression du navigateur
export const printPdfBlob = (data) => new Promise((resolve) => {
    if (printFrame) {
        if (printFrame.dataset.url) URL.revokeObjectURL(printFrame.dataset.url);
        printFrame.remove();
        printFrame = null;
    }
    const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:1px;height:1px;border:0;visibility:hidden;';
    iframe.dataset.url = url;
    let done = false;
    const finish = (fallback) => {
        if (done) return;
        done = true;
        if (fallback) window.open(url, '_blank');
        resolve();
    };
    iframe.onload = () => {
        setTimeout(() => {
            try {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
                finish(false);
            } catch {
                finish(true);
            }
        }, 200);
    };
    // Fallback si l'iframe ne charge pas (CSP, erreur) : ouvrir dans un onglet
    setTimeout(() => finish(true), 2500);
    iframe.src = url;
    document.body.appendChild(iframe);
    printFrame = iframe;
});

// Équivalent de openAuthPdf mais imprime au lieu d'ouvrir un onglet
export const printAuthPdf = async (url, errMsg = 'Erreur lors de la génération du PDF') => {
    const resp = await authFetch(url);
    if (!resp.ok) {
        const { toast } = await import('sonner');
        let detail = errMsg;
        try { detail = (await resp.json()).detail || errMsg; } catch { /* ignore */ }
        toast.error(detail);
        return;
    }
    await printPdfBlob(await resp.blob());
};
